import { Skeleton } from "@/components/ui/alert"
import { Pagination } from "@/components/ui/data-table"
import { TABLE_PAGE_SIZES } from "@/lib/table"

/*
   The engagement table's pager, split out of the page. `total` is `undefined` until the
   first page lands: a confident `0` while the request is in flight would tell the reader
   the list is empty, so an unknown total shows a skeleton in the pager's place instead.

   A skeleton is only right while the total is still coming. Once the list has failed the
   total is never arriving, and a skeleton left pulsing under the table promises an answer
   that is not coming — the table above already says what happened and offers the retry, so
   the pager renders nothing at all.
*/
export interface ClientsPagerProps {
  total: number | undefined
  /** The list request failed, so `total` will stay unknown. */
  failed: boolean
  page: number
  pageSize: number
  onPageChange: (page: number) => void
  onPageSizeChange: (size: number) => void
}

export function ClientsPager({
  total,
  failed,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
}: ClientsPagerProps): JSX.Element | null {
  if (failed) return null

  return (
    <div className="shrink-0 border-t border-border-soft">
      {total === undefined ? (
        <div className="flex h-11 items-center px-4">
          <Skeleton className="h-4 w-44" />
        </div>
      ) : (
        <Pagination
          page={page}
          pageSize={pageSize}
          total={total}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          pageSizes={[...TABLE_PAGE_SIZES]}
        />
      )}
    </div>
  )
}
